// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Pk6T","consentsList":"PatientConsents_consentsList__31yQ9","consentsListEmpty":"PatientConsents_consentsListEmpty__2Y_mJ"};